///<reference path="../../../typings/angularjs/angular.d.ts"/>
///<reference path="../../../typings/codemirror/codemirror.d.ts"/>
///<reference path="processEditor-module.ts"/>
///<reference path="environmentVariablesService.ts"/>

declare module CodeMirror {
    var hint: {
        frends: any;
    }
}
module ProcessEditor {
    'use strict';

    export class ReferencesService {
        private availableEnvironmentVariables: string[];
        private scopeVariables: IScopeVariable[];
        private pressedCharacter: string;

        static $inject = ["EnvironmentVariablesService", "ProcessService", "$timeout", "$rootScope"];
        constructor(environmentVariablesService: EnvironmentVariablesService, public processService: ProcessService, public $timeout: ng.ITimeoutService, public $rootScope) {
            environmentVariablesService.getEnvironmentVariables().success(parameters => {
                this.availableEnvironmentVariables = parameters;
            });
            this.availableEnvironmentVariables = [];
            this.scopeVariables = [];

            CodeMirror.registerHelper("hint", "frends", (editor, options) => this.getCompletions(editor, options));
        }

        /**
         * Returns the completions for the auto-complete menu
         * @param editor Codemirror editor
         * @param options options object, contains the nodeId
         * @returns {}
         */
        public getCompletions(editor: CodeMirror.Editor, options) {
            var data = this.getAllReferences(options.nodeId);

            // to keep it simple, just get the current line and check the word at the current position
            var cur = editor.getCursor();
            var currentLine = editor.getDoc().getLine(cur.line);

            var regex = /(\S*)$/; // simple split on whitespace for now
            var startOfToken = cur.ch; // default
            var token = regex.exec(currentLine.substr(0, cur.ch))[0];
            var completions = [];
            if (token) {
                var referenceRegex = /(#RESULT|#TRIGGER|#VAR|#ENV|#PROCESS)(\.[^\s\.\[\]\-\+\&\)]*|\[[^\]]*\])?/i;
                var refTokens = token.match(referenceRegex);
                if (!refTokens) {
                    // refTokens not defined -> just show the possible keys (env, var etc)
                    completions = _.filter(_.keys(data), h => h.indexOf(token) === 0);
                } else {
                    // filter the entries by the reftype + refkey
                    var refType = refTokens[1].toLowerCase();
                    var refKey = (refTokens[2] || "").toLowerCase();
                    var entries = data[refType];
                    completions = _.filter(entries, (r: string) => {
                        var result = r.indexOf(refType + refKey) === 0; // choice which start with the typed text
                        // if the typed text did not match, check if it would match by switching '.' and '[' as the first character
                        if (!result) {
                            if (refKey.indexOf(".") === 0) { // starts with ., try [
                                result = r.indexOf(refType + "[" + refKey.substring(1)) === 0;
                            } else if (refKey.indexOf("[") === 0) { // starts with [, try .
                                result = r.indexOf(refType + "." + refKey.substring(1)) === 0;
                            }
                        }

                        return result;
                    });
                }
                startOfToken = cur.ch - token.length;
            } else {
                // no token -> just show the possible keys
                completions = _.keys(data);
            }

            return {
                list: completions,
                from: CodeMirror.Pos(cur.line, startOfToken), // replace the current token
                to: cur
            }

        }

        private processReferences = ["uri", "id", "version", "name", "executionid"];

        /**
         * Gets the list of possible references for the current node
         * @param nodeId name of hte node
         * @returns dictionary of references, keyed by type
         */
        public getAllReferences(nodeId: string): IReferenceDictionary {
            function setReferences(data, refName: string, refValues: string[], forceBlock = false) {
                if (!_.isEmpty(refValues)) {
                    data[refName] = _.uniq(_.map(refValues, refValue => forceBlock || refValue.indexOf(" ") !== -1 ? `${refName}[${refValue}]` : `${refName}.${refValue}`));
                }
            }

            var data = <IReferenceDictionary>{};
            setReferences(data, "#env", this.availableEnvironmentVariables);

            setReferences(data, "#trigger", this.getAvailableTriggerReferences());

            setReferences(data, "#process", this.processReferences);

            var allScopeVariables = this.getScopeVariables(this.processService.currentProcess.rootScope);
            var variablesForScope = _.filter(allScopeVariables, (i: IScopeVariable) => nodeId.indexOf(i.scopeId) === 0 && nodeId !== i.nodeId);

            var resultVariablesForScope = _.map(_.filter(variablesForScope, v => v.type === VariableType.Result), v => v.name);
            setReferences(data, "#result", resultVariablesForScope, true);

            var varVariablesForScope = _.map(_.filter(variablesForScope, v => v.type === VariableType.Var), v => v.name);
            setReferences(data, "#var", varVariablesForScope);

            return data;
        }

        private getAvailableTriggerReferences(): string[] {
            var dataRefs = _.chain(this.processService.currentProcess.triggers)
                .map(t => {
                    switch (t.$type) {
                        case "HttpTrigger":
                            var refs = [
                                "data",
                                "data.httpBody",
                                "data.httpParameters",
                                "data.httpHeaders",
                                "data.httpMethod",
                                "data.httpRequestUri",
                                "data.httpClientIp",
                                "data.httpCookies"
                            ];
                            var uriParamRegex = /{\*?([^}]*)}/g;
                            var uriParamsMatch = uriParamRegex.exec(t.config.routeTemplate);
                            while (uriParamsMatch !== null) {
                                refs.push("data.httpParameters." + uriParamsMatch[1]); // is matched text, [1] i capture group
                                uriParamsMatch = uriParamRegex.exec(t.config.routeTemplate);
                            }
                            return refs;
                        case "FileWatchTrigger":
                            return ["data", "data.files", "data.filePaths"];
                        case "QueueTrigger":
                            return ["data", "data.applicationProperties", "data.body", "data.properties", "data.properties.messageId", "data.properties.absoluteExpiryTime", "data.properties.contentEncoding", "data.properties.contentType", "data.properties.correlationId", "data.properties.creationTime", "data.properties.groupId", "data.properties.groupSequence", "data.properties.replyToGroupId", "data.properties.replyTo", "data.properties.subject", "data.properties.userId", "data.properties.to"];
                        case "ServiceBusTrigger":
                            return ["data", "data.properties", "data.body"];
                        default:
                            return [];
                    };
                })
                .flatten()
                .value() as string[];

            return ["name", "type"].concat(dataRefs);
        }

        /**
         * Editor options for codemirror expression editors
         */
        public editorOptions = {
            showCursorWhenSelecting: true,
            inputStyle: "textarea",
            lineWrapping: true,
            extraKeys: {
                "Ctrl-Space": (cm: CodeMirror.Editor) => CodeMirror.showHint(cm, CodeMirror.hint.frends, {}),
                "Tab": false, // allow users to use tabs for tabbing between fields
                "Shift-Tab": false
            }
        }

        // These bindings happen once per CodeMirror instance initialization.
        public bindCodeMirrorEditorEvents(nodeId: string, form: ng.IFormController) {
            return (cm: CodeMirror.Editor) => {

                cm.on("keypress", (instance, event: KeyboardEvent) => {
                    var key = event.which;
                    this.pressedCharacter = String.fromCharCode(key);
                });

                // Registers autocomplete to trigger on specific keys: '.', '#' and '['
                // Called on codemirror.onLoad
                // Needed because '#' requires pressing shift, so extraKeys are not enough
                cm.on("keyup", (instance, event: KeyboardEvent) => {
                    // Don't do anything if backspace or delete are pressed
                    // 8 = backspace, 46 = delete
                    // Don't reinitialize the list, if arrow keys are pressed (the user wishes to navigate the list with arrow keys)
                    // 37 - 40 = arrow keys
                    // String.fromCharCode does not work for keys which produce no characters
                    var key = event.which;
                    if (key === 8 || key === 46 || key === 37 || key === 38 || key === 39 || key === 40) { return; }
                    if (/[\.#\[]/.test(this.pressedCharacter)) {
                        CodeMirror.showHint(instance, CodeMirror.hint.frends, {
                            nodeId: nodeId,
                            completeSingle: false
                        });
                    }
                });

                // Focusing on CodeMirror inputs don't set the $touched flag on the actual <TextArea> tag.
                // This messes up the validation styles, so manually set the form to dirty.
                cm.on("blur", (instance) => {
                    this.$timeout(() => {
                        form.$setDirty();
                    });
                });

                this.$rootScope.$on("validate.trigger.frends", (event) => {
                    // listen to forced validation requests and
                    // set the form as dirty so that validation error are shown correctly in the view
                    this.$timeout(() => {
                        form.$setDirty();
                    });
                });
            }
        }
        
        /**
         * Retrieves all scope-specific parameters (results and vars)
         * @param scopeNode
         * @returns {}
         */
        public getScopeVariables(scopeNode: ScopeNode): IScopeVariable[] {
            if (!scopeNode) {
                return [];
            }

            var tasksWithResult = _.filter(scopeNode.nodes, (n: Node) => (n instanceof TaskNode && !!n.returnType) || n instanceof ForeachScopeNode);
            var taskData = _.map(tasksWithResult, (n: TaskNode) => <IScopeVariable>{
                name: n.name,
                scopeId: scopeNode.nodeId,
                nodeId: n.nodeId,
                type: VariableType.Result
            });

            _.each(scopeNode.nodes, (n: INodeWithErrorHandler) => {
                if (n instanceof ScopeNode) {
                    taskData = taskData.concat(this.getScopeVariables(n));
                } else if (n.errorHandler) {
                    taskData = taskData.concat(this.getScopeVariables(n.errorHandler));
                }
            });

            if (scopeNode.errorHandler) {
                taskData = taskData.concat(this.getScopeVariables(scopeNode.errorHandler));
            }

            if (scopeNode instanceof ForeachScopeNode) {
                const startNode = <ForeachScopeStartNode>_.find(scopeNode.nodes, (n) => n instanceof ForeachScopeStartNode);
                taskData.push({
                    name: startNode.iterationVariable,
                    scopeId: scopeNode.nodeId,
                    nodeId: startNode.nodeId,
                    type: VariableType.Var
                });
                taskData.push({
                    name: startNode.iterationVariable + '_index',
                    scopeId: scopeNode.nodeId,
                    nodeId: startNode.nodeId,
                    type: VariableType.Var
                });
            }

            if (scopeNode instanceof ErrorScopeNode) {
                const startNode = <ErrorScopeStartNode>_.find(scopeNode.nodes, (n) => n instanceof ErrorScopeStartNode);
                taskData.push({
                    name: startNode.errorVariable,
                    scopeId: scopeNode.nodeId,
                    nodeId: startNode.nodeId,
                    type: VariableType.Var
                });
            }

            return taskData;
        }
    }

    app.service("ReferencesService", ReferencesService);

    export interface IScopeVariable {
        name: string;
        type: VariableType;
        nodeId: string;
        scopeId: string;
    }

    enum VariableType {
        Var,
        Result
    }

    export interface IReferenceDictionary {
        [refType: string]: string[];
    }

    export function refreshCodemirrorOnShow() {
        return {
            restrict: "A",
            link: ($scope: ng.IScope) => {
                $scope.$on("show.editor.frends", () => {
                    // refresh using the event registration
                    $scope.$broadcast("CodeMirror", (cm: CodeMirror.Editor) => {
                        cm.refresh();
                    });
                });
            }
        }
    }

    app.directive("frendsRefreshCodemirrorOnShow", [refreshCodemirrorOnShow]);
}